var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgSwift = function SvgSwift(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.203 37.907c-4.95 2.848-11.758 3.14-18.607.218C9.051 35.775 4.45 31.663 1.5 26.965c1.416 1.175 3.068 2.115 4.837 2.937 7.073 3.3 14.145 3.075 19.121.008-7.079-5.404-13.104-12.461-17.587-18.217-.944-.94-1.652-2.114-2.36-3.172 5.427 4.934 14.04 11.16 17.107 12.923C16.13 14.63 10.348 6.172 10.584 6.407 20.85 16.744 30.406 22.619 30.406 22.619c.316.177.56.325.757.457a15.39 15.39 0 0 0 .54-1.632C33.355 15.453 31.468 8.639 27.338 3c9.556 5.756 15.22 16.564 12.86 25.61-.062.244-.129.485-.2.721 4.718 5.874 3.503 12.202 2.913 11.027-2.56-4.988-7.298-3.463-9.708-2.45Z",
    fill: "url(#swift_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "swift_svg__a",
    x1: 22.515,
    y1: 3,
    x2: 22.515,
    y2: 40.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD2020"
  })))));
};

export default SvgSwift;